import Repository from './repository'

export default {
  getNeighbors({ propertyId }) {
    return Repository.get(`/v1/user/properties/${propertyId}/neighbors`)
  },
}
